<template>
  <v-container fluid grid-list-lg transition="slide-x-transition">
    <v-card>
      <v-card-title>
        <v-btn
          fab
          dark
          small
          color="teal"
          @click="exportXLS"
          title="Exportar a XLS"
        >
          <v-icon dark>save_alt</v-icon>
        </v-btn>
        <div class="title">{{ pagename }}</div>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar..."
          single-line
          hide-details
        ></v-text-field>

        <!-- <v-dialog v-model="dialogPsw" max-width="500px">
                    <v-card>
                        <v-form
                        ref="formUserPsw"
                        class="pa-4"
                        v-model="validFormPsw"
                        lazy-validation
                        >
                        <! v-on:submit.prevent="submitUser" >
                            <v-card-title>
                                <span class="headline">Cambio de Contraseña</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field 
                                            type="password" 
                                            v-model="editedItem.newpassword" 
                                            :error-messages="passwordMatchError"
                                            :rules="newpasswordRules" 
                                            label="Contraseña">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field 
                                            type="password" 
                                            v-model="editedItem.repassword" 
                                            :error-messages="passwordMatchError"
                                            :rules="repasswordRules" 
                                            label="Repetir Contraseña">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click="closePsw">Cancelar</v-btn>
                                <v-btn color="blue darken-1" flat @click="savePsw" :disabled="!validFormPsw">Guardar</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
        </v-dialog>-->

        <v-dialog v-model="dialog" max-width="500px">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">Editar paciente</v-btn> -->
          <v-card>
            <v-form
              ref="formUser"
              class="pa-4"
              v-model="validForm"
              lazy-validation
            >
              <!-- v-on:submit.prevent="submitUser" -->
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        :rules="requireRules"
                        v-model="editedItem.nombre_paciente"
                        label="Nombre"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        :rules="rutRules"
                        v-model="editedItem.rut_paciente"
                        label="Rut"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6
                      ><!-- fechaNac_paciente -->
                      <v-menu
                        ref="menuFechaNac"
                        v-model="menuFechaNac"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        max-width="290px"
                        min-width="290px"
                        full-width
                        lazy
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <!-- 
                              :value="formatDate(editedItem.fecha_nacimiento)" 
                              v-model="fecha_nacimiento_formated"
                            @input="editedItem.fecha_nacimiento = formatDate(fecha_nacimiento_formated)"
                            -->
                          <v-text-field
                            v-model="editedItem.fecha_nacimiento"
                            :rules="requireRules"
                            label="Fecha nacimiento paciente"
                            hint="DD/MM/YYYY"
                            v-on="on"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.fecha_nacimiento"
                          @input="menuFechaNac = false"
                          first-day-of-week="1"
                          locale="es-cl"
                          no-title
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="email"
                        :rules="emailRules"
                        v-model="editedItem.correo"
                        label="Correo"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        :rules="requireRules"
                        v-model="editedItem.sexo_paciente"
                        :items="['F', 'M']"
                        label="Sexo"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12
                      ><!-- antecedente_clinicos -->
                      <v-textarea
                        v-model="editedItem.antecedente_clinicos"
                        label="Antecedentes clínicos"
                        color="primary"
                        box
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray darken-1" flat @click="close"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click="save"
                  :disabled="!validForm"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="desserts"
        class="elevation-1"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <tr :data-item="JSON.stringify(props.item)">
            <td>{{ props.item.nombre_paciente }}</td>
            <td class="text-xs-left">{{ props.item.rut_paciente }}</td>
            <td class="text-xs-left">{{ props.item.correo }}</td>
            <td class="text-xs-left">{{ props.item.sexo_paciente }}</td>
            <td class="text-xs-left">{{ props.item.alive }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="mr-2" @click="editItem(props.item)"
                >edit</v-icon
              >
              <!-- <v-icon
                                small
                                class="mr-2"
                                @click="changepswItem(props.item)"
                            >
                                vpn_key
                            </v-icon>
                            <v-icon
                                small
                                @click="deleteItem(props.item)"
                            >
                                delete
              </v-icon>-->
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Recargar</v-btn>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning"
            >Su busqueda para "{{ search }}" no obtuvo resultados.</v-alert
          >
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { bus } from "./../main";
import axios from "axios";
var moment = require("moment");
//var validaRut = require("./../plugins/Rut");
import { validaRut } from "./../plugins/Rut";
import { json2excel } from "js2excel";

export default {
  data: (vm) => ({
    pagename: "PACIENTES",
    logged_user: null,
    roles: [],
    dialog: false,
    dialogPsw: false,
    snack: false,
    snackColor: "",
    snackText: "",
    headers: [
      { text: "Nombre", align: "left", value: "nombre_paciente" },
      { text: "Rut", align: "left", value: "rut_paciente" },
      { text: "Correo", align: "left", value: "correo" },
      { text: "Sexo", align: "left", value: "sexo_paciente" },
      { text: "Creado", value: "fecha_registro" },
      { text: "Acciones", sortable: false },
    ],
    pagination: {
      sortBy: "fecha_registro",
      descending: true,
      rowsPerPage: 10,
    },
    search: "",
    desserts: [],
    editedIndex: -1,
    editedItem: {
      id: null,
      nombre_paciente: "",
      rut_paciente: "",
      correo: "",
      sexo_paciente: "",
      fecha_nacimiento: "",
      fecha_nacimiento_formated: null,
      fecha_registro: moment({}).format("YYYY-MM-DD H:mm:ss"),
      antecedente_clinicos: "",
    },
    defaultItem: {
      nombre_paciente: "",
      rut_paciente: "",
      correo: "",
      sexo_paciente: "",
      fecha_nacimiento: moment({}).format("YYYY-MM-DD"),
      fecha_nacimiento_formated: null,
      fecha_creacion: moment({}).format("YYYY-MM-DD H:mm:ss"),
      antecedente_clinicos: "",
    },
    fecha_nacimiento_formated: null,
    validForm: false,
    validFormPsw: false,
    menuFechaNac: false,
    requireRules: [(v) => !!v || "Campo es requerido"],
    rutRules: [
      (v) => !!v || "Rut es requerido",
      (v) => validaRut(v) || "El rut debe ser válido",
    ],
    emailRules: [
      // v => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || !v || "El correo debe ser válido",
    ],
    newpasswordRules: [
      (v) => !!v || "Password es requerido",
      (v) => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
      // v => v === this.editedItem.repassword || "Ambos password deben ser iguales"
    ],
    repasswordRules: [
      (v) => !!v || "Password es requerido",
      (v) => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
      // v => v === this.editedItem.newpassword || "Ambos password deben ser iguales"
    ],
    exportable: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Paciente" : "Editar Paciente";
    },
    passwordMatchError() {
      return this.editedItem.newpassword === this.editedItem.repassword
        ? ""
        : "Ambos password deben ser iguales";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));

    if (this.logged_user && this.logged_user.id_perfil == 4) {
      this.$router.push({ name: "Find" });
    }

    const getUsuarios = axios.create({
      timeout: 10000,
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "x-www-form-urlencoded",
      },
      params: {
        accion: "pacientes",
        opcion: "listarPacientes",
        api_token: this.logged_user.api_token,
      },
    });

    getUsuarios
      .get(window.base_path + window.ws)
      .then((result) => {
        if (result.data.response) {
          // console.log(JSON.parse(JSON.stringify(result.data.callback)));
          result.data.callback.forEach((element) => {
            element.alive = moment(element.fecha_registro)
              .locale("es")
              .fromNow();
            this.exportable.push({
              rut_paciente: element.rut_paciente,
              nombre_paciente: element.nombre_paciente,
              sexo_paciente: element.sexo_paciente,
              fecha_nacimiento_paciente: element.fecha_nacimiento,
              correo_paciente: element.correo,
              fecha_registro_paciente: element.fecha_registro,
            });
          });

          this.initialize(result.data.callback);
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });

    const getRoles = axios.create({
      timeout: 10000,
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "x-www-form-urlencoded",
      },
      params: {
        accion: "roles",
        api_token: this.logged_user.api_token,
      },
    });

    getRoles
      .get(window.base_path + window.ws)
      .then((result) => {
        // console.log(JSON.parse(JSON.stringify(result)))
        if (result.data.response) {
          this.roles = result.data.callback;
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });
  },

  methods: {
    initialize(data) {
      this.desserts = data;
      /*[
                    {
                        name: 'Frozen Yogurt',
                        calories: 159,
                        fat: 6.0,
                        carbs: 24,
                        protein: 4.0
                    },
                    {
                        name: 'Ice cream sandwich',
                        calories: 237,
                        fat: 9.0,
                        carbs: 37,
                        protein: 4.3
                    },
                    {
                        name: 'Eclair',
                        calories: 262,
                        fat: 16.0,
                        carbs: 23,
                        protein: 6.0
                    },
                    {
                        name: 'Cupcake',
                        calories: 305,
                        fat: 3.7,
                        carbs: 67,
                        protein: 4.3
                    },
                    {
                        name: 'Gingerbread',
                        calories: 356,
                        fat: 16.0,
                        carbs: 49,
                        protein: 3.9
                    },
                    {
                        name: 'Jelly bean',
                        calories: 375,
                        fat: 0.0,
                        carbs: 94,
                        protein: 0.0
                    },
                    {
                        name: 'Lollipop',
                        calories: 392,
                        fat: 0.2,
                        carbs: 98,
                        protein: 0
                    },
                    {
                        name: 'Honeycomb',
                        calories: 408,
                        fat: 3.2,
                        carbs: 87,
                        protein: 6.5
                    },
                    {
                        name: 'Donut',
                        calories: 452,
                        fat: 25.0,
                        carbs: 51,
                        protein: 4.9
                    },
                    {
                        name: 'KitKat',
                        calories: 518,
                        fat: 26.0,
                        carbs: 65,
                        protein: 7
                    }
                ]*/
    },

    aaa(date) {
      this.fecha_nacimiento_formated = moment(date).format("L");
    },

    formatDate(date) {
      // console.log('FD', date)
      return date; //moment(date).format('YYYY-MM-DD')
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      // item.fecha_creacion = moment({}).format()
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);

      //confirm('¿Está seguro que desea eliminar este usuario?') //&& this.desserts.splice(index, 1)
      if (confirm("¿Está seguro que desea eliminar este paciente?")) {
        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: {
            api_token: this.logged_user.api_token,
            accion: "usuarios",
            opcion: "borrar",
            idUsuario: item.id,
          },
        })
          .then((result) => {
            // console.log(result)
            if (result.data.response) {
              this.snackColor = "success";
              this.snackText = result.data.mensaje;
              this.desserts.splice(index, 1);
            } else {
              this.snackColor = "error";
              this.snackText = result.data.mensaje;
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      /*
                    $_REQUEST['idUsuario']
                    $_REQUEST['nombres'], 
                    $_REQUEST['apellidos'], 
                    $_REQUEST['login'], 
                    $_REQUEST['password']), 
                    $_REQUEST['idrol']

                    id: null,
                    nombre_paciente: "",
                    rut_paciente: "",
                    correo: "",
                    sexo_paciente: "",
                    fecha_registro:
                */
      var newrow = Object.assign({}, this.editedItem);
      var contentData = {
        api_token: this.logged_user.api_token,
        accion: "pacientes",
        opcion: this.editedIndex > -1 ? "editarPaciente" : "", //nuevoPaciente
        id_paciente: this.editedIndex > -1 ? this.editedItem.id_paciente : null,
        nombrePaciente: this.editedItem.nombre_paciente,
        correoPaciente: this.editedItem.correo,
        fechaNacimiento: this.editedItem.fecha_nacimiento,
        sexoPaciente: this.editedItem.sexo_paciente,
        rutPaciente: this.editedItem.rut_paciente,
        antecedentesClinicos: this.editedItem.antecedente_clinicos,
      };
      // console.log('contentData', contentData)

      if (this.$refs.formUser.validate()) {
        // console.log("formulario válido");
        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            // console.log(result)
            if (result.data.response) {
              // console.log("response true", this.editedIndex);
              this.snackColor = "success";
              this.snackText = result.data.mensaje;
              if (this.editedIndex > -1) {
                // console.log("edit");
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
              } else {
                //console.log('insert', result.data.callback, JSON.parse(JSON.stringify(this.editedItem)))
                newrow.id = result.data.callback.usuario_id;
                newrow.fecha_creacion = result.data.callback.date;
                newrow.alive = moment(result.data.callback.date)
                  .locale("es")
                  .fromNow();

                this.desserts.push(newrow);
                // console.log("editedItem", JSON.parse(JSON.stringify(newrow)));
              }
              //setTimeout(() => {
              this.$refs.formUser.reset();
              this.close();
              //}, 1000)
            } else {
              // console.log("response false");
              this.snackColor = "error";
              this.snackText = result.data.mensaje;
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      } else {
        // console.log("formulario inválido");
      }

      //return

      /* const editUsuarios = axios.create({
                    timeout: 10000,
                    withCredentials: true,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'x-www-form-urlencoded',
                    },
                    params: contentData
                }); */

      /*
                    editUsuarios.post(window.base_path + window.ws)
                    .then(result => {
                        console.log(JSON.parse(JSON.stringify(result)))
                        
                        if (result.data.response) {

                        } else {
                            // bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
                        }
                        
                    }).catch(error => {
                        // console.log('error',error)
                        // bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
                    })
                */
    },

    changepswItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogPsw = true;
      // console.log("changepswItem");
      // console.log(JSON.parse(JSON.stringify(this.editedItem)));
    },

    closePsw() {
      this.dialogPsw = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    savePsw() {
      console.log("savePsw");

      if (this.$refs.formUserPsw.validate()) {
        console.log("formulario válido");
        console.log(JSON.parse(JSON.stringify(this.editedItem)));

        var contentData = {
          api_token: this.logged_user.api_token,
          accion: "usuarios",
          opcion: "modificarCalve",
          idUsuario: this.editedItem.id,
          password: this.editedItem.newpassword,
        };

        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            // console.log(result)
            if (result.data.response) {
              // console.log('response true', this.editedIndex)
              this.snackColor = "success";
              this.snackText = result.data.mensaje;
              //setTimeout(() => {
              this.$refs.formUserPsw.reset();
              this.closePsw();
              //}, 1000)
            } else {
              // console.log("response false");
              this.snackColor = "error";
              this.snackText = result.data.mensaje;
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      } else {
        // console.log("formulario inválido");
      }
    },

    validarRut(v) {
      if (v.length > 0) {
        return validaRut(v);
      }
      return true;
    },
    exportXLS() {
      try {
        let data = this.exportable;
        json2excel({
          data,
          name: "listado-pacientes",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        //console.error('export error');
      }
    },
  },
};
</script>
